module.exports = __webpack_public_path__ + "static/media/caret-down-new.cee0867e.svg";